import React from 'react';
import { IonBadge, IonIcon } from '@ionic/react';
import { cloudOfflineOutline } from 'ionicons/icons';
import type { Device } from '../../domain/Device';
import { connectivityOf, formatSince } from '../../domain/connectivity';
import { formatRelative } from '../../domain/WeatherStation';

const offlineStyle = {
  '--background': 'var(--domiot-offline-tint)',
  '--color': 'var(--domiot-offline)',
  border: '1px solid var(--domiot-offline-border)',
} as React.CSSProperties;

type DeviceSignal = Pick<Device, 'status' | 'lastSeenAt'>;

// "En línea" / "Sin conexión" / "Sin datos todavía", igual en toda la app.
export const ConnectivityBadge: React.FC<{ device: DeviceSignal; style?: React.CSSProperties }> = ({ device, style }) => {
  const c = connectivityOf(device);
  if (c.state === 'online') {
    return (
      <IonBadge color="success" style={style}>
        {c.label}
      </IonBadge>
    );
  }
  return <IonBadge style={{ ...offlineStyle, ...style }}>{c.label}</IonBadge>;
};

// Aviso de corte: deja claro que lo que se ve es de antes de que se cayera,
// como el cartel de "línea parada" en un tablero de producción.
export const ConnectivityBanner: React.FC<{ device: DeviceSignal }> = ({ device }) => {
  const c = connectivityOf(device);
  if (c.state !== 'offline') return null;
  return (
    <div className="connectivity-banner" role="status">
      <IonIcon icon={cloudOfflineOutline} />
      <div>
        <strong>
          Sin conexión desde {formatSince(c.since)} ({formatRelative(c.since)})
        </strong>
        <span>Los valores que ves son los últimos que llegaron. Revisá la alimentación y el internet del equipo.</span>
      </div>
    </div>
  );
};
